'use client';

import NumberFormatter from '@/utils/bn';
import { cn } from '@tajdid/tajdid-ui';
import { useLocale, useTranslations } from 'next-intl';

type ModuleBadgeProps = {
  moduleIndex: number;
  className?: string;
};

export default function ModuleBadge({
  moduleIndex = 0,
  className,
}: ModuleBadgeProps) {
  const t = useTranslations();
  const locale = useLocale();

  return (
    <div className={cn('px-2 py-[3px] rounded-[6px] bg-gray-100', className)}>
      <span className="text-gray-800 text-sm font-medium">
        {t('course-details.module')}{' '}
        {locale === 'bn' ? NumberFormatter(moduleIndex) : moduleIndex}
      </span>
    </div>
  );
}
